query($eventId: UUID!) {
  event: eventByEventId(eventId: $eventId) {
    eventId
    eventName
    startsAt
    status
    matchState
    sportId
    competitors
    isUsaView
    eventType
    source
    limbo
    sport {
      sportId
      sportName
      sportLabel
    }
    competitors
    competition {
      competitionId
      competitionName
      competitionFeedConfiguration: competitionFeedConfigurationsByCompetitionId {
        nodes {
          feed
          priority
        }
      }
    }
    eventHasExternalPricesByEventId {
      nodes {
        hasExternalPrices
      }
    }
    eventHasInternalPricesByEventId {
      nodes {
        hasInternalPrices
      }
    }
    eventIsMappedsByEventId {
      nodes {
        isMapped
      }
    }
    eventIsCoveredsByEventId {
      nodes {
        available
        eventId
      }
    }
    operatorEventSuspensionsByEventId {
      nodes {
        operatorId
      }
    }
    eventReadiness: eventReadinessByEventId {
      isApproved
    }
    region {
      regionId
      regionName
    }
    booked: bookedEventsByEventId {
      nodes {
        bookedAt
        bookedBy
        pricingMode
      }
    }
    eventHighlightsByEventId {
      nodes {
        nodeId
      }
    }
    appliedTemplates: eventAppliedTemplatesByEventId {
      nodes {
        sportTemplate: appliedSportTemplate {
          sportTemplateId
          name
        }
      }
    }
    limitConfiguration: eventAppliedLimitConfigurationsByEventId {
      nodes {
        limitConfiguration
      }
    }
    markets: marketsByEventId(
      filter: { source: { in: ["INTERNAL_AGGREGATION"] } }
    ) {
      nodes {
        displayStatus
        offeringStatus
        resultingStatus
        marketCode
        marketId
        marketType
        selections
        source
        inPlay
        marketSummary
        limitConfiguration
        gateway
        suspensionReason
      }
    }
    marketsOfferingStatus: operatorMarketTypeSuspensionForAllLinesByEventId {
      nodes {
        marketTypeWithoutLine
        operatorId
      }
    }
    primaryFeedOverrides: eventPrimaryFeedOverridesByEventId {
      nodes {
        primaryFeeds
      }
    }
    pricingProbabilitiesByEventId {
      nodes {
        eventId
        operatorId
        probabilities
        sportsLabel
      }
    }
    soccerEventDetails: soccerAggregatesByEventId {
      nodes {
        actions
        attacksInMatch
        attacksPerPeriod
        available
        awayLineup
        awayScore
        awayScoreFirstLeg
        awayScorePenaltyShootout
        awayScoreRegularTime
        awayTeamId
        competitionType
        cornersInMatch
        cornersPerPeriod
        dangerousAttacksInMatch
        dangerousAttacksPerPeriod
        dangerousFreeKicksInMatch
        dangerousFreeKicksPerPeriod
        elapsedSecondInPeriod
        eventId
        eventInBreak
        eventPreMatch
        extraTimeHalfDuration
        firstYellowCardsInMatch
        firstYellowCardsPerPeriod
        foulsInMatch
        foulsPerPeriod
        freeKicksInMatch
        freeKicksPerPeriod
        goalKicksInMatch
        goalKicksPerPeriod
        halfDuration
        homeLineup
        homeScore
        homeScoreFirstLeg
        homeScorePenaltyShootout
        homeScoreRegularTime
        homeTeamId
        injuryTimeDuration
        injuryTimeDurationOfficial
        lastAction
        maxSubstitutions
        penaltiesInMatch
        penaltiesPerPeriod
        period
        redCardsInMatch
        redCardsPerPeriod
        riskFlags
        scorePerPeriod
        secondLeg
        shotsOffTargetInMatch
        shotsOffTargetPerPeriod
        shotsOnTargetInMatch
        shotsOnTargetPerPeriod
        source
        substitutionsInMatch
        substitutionsPerPeriod
        teamInPossession
        throwInsInMatch
        throwInsPerPeriod
        var
        varEnabled
        yellowCardsInMatch
        yellowCardsPerPeriod
        ownGoalsPerPeriod
        goalsFromPenaltyPerPeriod
        offsidesPerPeriod
        ownGoalsInMatch
        goalsFromPenaltyInMatch
        offsidesInMatch
        assistsInMatch
        accuratePassesInMatch
        totalPassesInMatch
        accurateCrossesInMatch
        totalCrossesInMatch
        tacklesInMatch
        interceptionsInMatch
        savesInMatch
        hydrationBreakInProgress
        hydrationBreakStartTime
      }
    }
    basketballEventDetails: basketballAggregatesByEventId {
      nodes {
        homeTeamId
        awayTeamId
        homeScore
        awayScore
        foulThresholdForBonus
        foulsPerPeriod
        eventId
        ftsToCome
        nodeId
        onePointersPerPeriod
        otLengthInMinutes
        otPossible
        periodLengthInMinutes
        periods
        scorePerPeriod
        secondsLeftInPeriod
        teamInPossession
        threePointersPerPeriod
        twoPointersPerPeriod
        lastTeamToScore
        competitionType
        period
        clockRunning
        source
        homeLineup
        awayLineup
        fieldGoalPerPeriod
        fieldGoalPercentagePerPeriod
        fieldGoalPercentageInMatch
        twoPointAttemptsPerPeriod
        threePointAttemptsPerPeriod
        reboundsPerPeriod
        assistsPerPeriod
        possessionsCountPerPeriod
        eventInBreak
        eventPreMatch
        actions
        stealsPerPeriod
        turnoversPerPeriod
        offensiveReboundsPerPeriod
        blocksPerPeriod
        available
        timeoutInProgress
        timeoutTeam
        timeoutStartTime
        tvTimeoutInProgress
        tvTimeoutStartTime
        timeoutsRemaining
      }
    }
    footballEventDetails: footballAggregatesByEventId {
      nodes {
        period
        gameTimeFromLastScoringEvent
        gameTimeElapsedInPeriod
        gameTimeRemainingInRegularGame
        inPossession
        downNumber
        yardsToWinDown
        lineOfScrimmageYard
        lineOfScrimmageTerritory
        yardsToEndZone
        isConversionEvent
        homeScore
        awayScore
        homeScoreFirstQuarter
        awayScoreFirstQuarter
        homeScoreSecondQuarter
        awayScoreSecondQuarter
        homeScoreThirdQuarter
        awayScoreThirdQuarter
        homeScoreFourthQuarter
        awayScoreFourthQuarter
        homeScoreOvertime
        awayScoreOvertime
        competitionName
        totalDownsNumber
        quarterDuration
        overtimeDuration
        overtimePossible
        homeTeamId
        awayTeamId
        source
        homeLineup
        awayLineup
        drives
        eventInBreak
        eventPreMatch
        isPlayRunning: playRunning
        awayTimeoutsLeft
        homeTimeoutsLeft
        available
        timeoutInProgress
        timeoutTeam
        timeoutStartTime
        tvTimeoutInProgress
        tvTimeoutStartTime
      }
    }
    ultimateEventDetails: ultimateAggregatesByEventId {
      nodes {
        homeTeamId
        awayTeamId
        homeScore
        awayScore
        eventId
        nodeId
        available
        clockRunning
        lastTeamToScore
        lastUpdated
        numberOfPeriods
        overTimeLengthMinutes
        period
        periodLengthMinutes
        pitchLengthMeters
        pitchWidthMeters
        scorePerPeriod
        secondsLeftInPeriod
        source
        teamInPossession
        eventInBreak
        eventPreMatch
      }
    }
    hockeyEventDetails: hockeyAggregatesByEventId {
      nodes {
        eventId
        lastTeamToScore
        period
        secondsLeftInPeriod
        scorePerPeriod
        foulsPerPeriod: penaltiesPerPeriod
        periods
        periodLengthInMinutes
        competitionType
        otPossible
        otLengthInMinutes
        homeTeamId
        awayTeamId
        homeScore
        awayScore
        clockRunning
        timeOfLastClockStart
        lastUpdated
        source
        available
        teamInPossession
        eventInBreak
        eventPreMatch
        homeLineup
        awayLineup
        shotsOnGoal
        shotsOffTarget
        blockedShots
        goalsScoredOnEmptyNet
        powerPlayPercentage
        totalShotsOnGoal
        totalShotsOffTarget
        totalBlockedShots
        totalGoalsScoredOnEmptyNet
        totalPowerPlayPercentage
        powerPlayAdvantage
        timeoutInProgress
        timeoutTeam
        timeoutStartTime
        tvTimeoutInProgress
        tvTimeoutStartTime
        timeoutsRemaining
      }
    }
    baseballEventDetails: baseballAggregatesByEventId {
      nodes {
        eventId
        source
        lastUpdated
        matchRuns
        pitchCount
        loadedBases
        matchHits
        inningDetails
        currentTeamAPitcherProviderId
        currentTeamABatterProviderId
        currentTeamAPitcherId
        currentTeamABatterId
        currentTeamBPitcherProviderId
        currentTeamBBatterProviderId
        currentTeamBPitcherId
        currentTeamBBatterId
        teamABatterIds
        teamBBatterIds
        teamAPitcherIds
        teamBPitcherIds
        matchHomeRuns
        raceToMap
        available
        extraInningsSecondBaseRule
        regularInningsToBePlayed
        mercyRulePossible
        mercyRuleInningThreshold
        mercyRuleRunsAheadThreshold
        tiePossible
        tiePossibleInningThreshold
        homeTeamId
        awayTeamId
        eventInBreak
        eventPreMatch
        pitchCount
        loadedBases
        awayLineup
        homeLineup
        strikeOuts
        tvTimeoutInProgress
        tvTimeoutStartTime
      }
    }
    tennisEventDetails: tennisAggregatesByEventId {
      nodes {
        source
        lastUpdated
        homeTeamId
        awayTeamId
        available
        period
        matchTime
        setDurations
        currentServingTeam
        currentGameNumber
        currentGameScore
        pointsWonPerGame
        gamesWonInMatch
        gamesWonPerSet
        setsWon
        isPointInProgress
        secondServe
        eventPrematch
        eventPostmatch
        eventInBreak
        setsToPlay
        isDoubles
        isMen
        noAdvantage
        lastSetSuperTiebreak
        lastScoreUpdate
        lastSetSuperTiebreakPoints
        acesInMatch
        acesPerSet
        doubleFaultsInMatch
        doubleFaultsPerSet
        breakPointsPlayedInMatch
        breakPointsWonInMatch
        breakPointsPlayedPerSet
        breakPointsWonPerSet
        breakPointsWonPercentageInMatch
        breakServePointsWonPercentagePerSet
        firstServePercentageInMatch
        firstServePercentagePerSet
        firstServePointsPlayedInMatch
        firstServePointsPlayedPerSet
        firstServePointsWonInMatch
        firstServePointsWonPerSet
        firstServePointsWonPercentageInMatch
        firstServePointsWonPercentagePerSet
        secondServePercentageInMatch
        secondServePercentagePerSet
        secondServePointsPlayedInMatch
        secondServePointsPlayedPerSet
        secondServePointsWonInMatch
        secondServePointsWonPerSet
        secondServePointsWonPercentageInMatch
        secondServePointsWonPercentagePerSet
      }
    }
    operatorEventUndisplaysByEventId {
      nodes {
        eventId
      }
    }
  }
}
